import Endpoints from '@commons/communication/endpoints.js'
import CustomPage from '@pages/page/CustomPage.vue'
import Footer from '@components/bora/Footer.vue'


export default{
    mixins:[Endpoints],
    components:{
        CustomPage,
        FooterView:Footer,
    },
    data:function () {
        return {
            menus: [],
            config: {
                slidesPerView: 'auto',
                spaceBetween: 20,
            },
        };
    },
    created: function (){
        var self = this;
        this.connGetMenusTree('WEBSHOP_MAIN',function (r) {
            self.menus = r.data.list;

            self.$nextTick(function () {
                // $('.owl-carousel').owlCarousel({
                //     nav:false,
                //     // navText: ["<i class='fa fa-chevron-left'>","<i class='fa fa-chevron-right'>"],
                //     autoWidth:true,
                //     margin:15
                // })
                if (self.$refs.swiper){
                    self.$refs.swiper.swiper.update();
                }
            })
        })

    },
    methods: {

    }
}



// WEBPACK FOOTER //
// ./src/app/main/components/MainPage.js